"use client";

import { FC } from "react";
import { usePathname } from "next/navigation";

import { useAppDispatch } from "@/redux/store";
import { resetRoom, setComments } from "@/redux/actions";
import Shortcut from "../Shortcut";
import OutlinedIcon from "@/components/icons/AddCircleOutlined";
import FilledIcon from "@/components/icons/AddCircle";

interface GenerateImagesProps {
  onClose: () => void;
}

const GenerateImages: FC<GenerateImagesProps> = ({ onClose }) => {
  const dispatch = useAppDispatch();
  const pathname = usePathname() as string;

  const handleCreateNewIdea = () => {
    dispatch(resetRoom());
    dispatch(setComments([]));
    onClose();
  };

  return (
    <Shortcut
      url="/idea"
      icon={<OutlinedIcon />}
      activeIcon={<FilledIcon />}
      label="Generate Images"
      onClick={handleCreateNewIdea}
      isActive={pathname.startsWith("/idea")}
    />
  );
};

export default GenerateImages;
